if (!window.Eurus.loadedScript.includes('tooltip.js')) {
  window.Eurus.loadedScript.push('tooltip.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.store("xTooltip", {
        show: false,
        text: '',
        posX: 0,
        posY: 0,
        defaultPosition: 'top',

        showTooltip(event, message, defaultPosition = 'top') {
          this.text = message;
          this.defaultPosition = defaultPosition;

          let parent = event.target;
          let tooltip = document.querySelector('.tooltip-container');
          if (!tooltip || !parent) return;
          let parentRect = parent.getBoundingClientRect();
          let scrollOffset = window.scrollY || document.documentElement.scrollTop;
          this.posX = parentRect.left + parentRect.width / 2;
          this.posY = parentRect.top + scrollOffset;

          if (defaultPosition === 'top') {
            this.posY = parentRect.top + scrollOffset - 4;
          } else if (defaultPosition === 'bottom') {
            this.posY = parentRect.bottom + scrollOffset + 12;
          } else if (defaultPosition === 'left') {
            this.posX = parentRect.left - tooltip.offsetWidth - 12;
            this.posY = parentRect.top + parentRect.height / 2 + scrollOffset;
          } else if (defaultPosition === 'right') {
            this.posX = parentRect.right + 12;
            this.posY = parentRect.top + parentRect.height / 2 + scrollOffset;
          }
          this.show = true;
        },

        hideTooltip() {
          this.show = false;
        }
      });
    });
  });
}
